// ============================================
// COSMIC HINDU - Discount Service
// ============================================

import api from './api';

const discountService = {
  async getAll()         { return api.get('get-discounts.php'); },
  async save(payload)    { return api.post('save-discounts.php', payload); },
  async validateCoupon(code, orderTotal) {
    return api.post('validate-coupon.php', { code, order_total: orderTotal });
  },

  // Client-side: apply discount rules to a price
  applyToPrice(price, discounts, categoryId) {
    if (!discounts?.length) return price;
    let best = 0;
    for (const d of discounts) {
      if (!d.active) continue;
      if (d.scope !== 'all' && d.scope_value !== categoryId) continue;
      const save = d.type === 'percentage' ? (price * d.value) / 100 : d.value;
      if (save > best) best = save;
    }
    return Math.max(0, price - best);
  },
};

export default discountService;
